<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wPyXAK/tc-custom/9781399010771.jpg?1718106148686" alt="This image is the cover for the book Trotsky, The Passionate Revolutionary"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Trotsky, The Passionate Revolutionary
      </h1>
      <p class="bookDescription body article font2">
        <p>Although Trotsky was dramatically assassinated just over eighty years ago, he remains a controversial figure. He has had many biographers over the decades - ranging from the overly-sympathetic, to the extremely-hostile. Robert Service, his most recent biographer, expressed the hope that his book would ‘finish off’ Trotsky - a job he believed the ice-axe had failed to do in 1940!  This biography, as expected, deals with those aspects for which Trotsky is noted: his passionate and fiery oratory which captivated and inspired huge crowds; organising the Bolshevik Revolution of November 1917; masterminding the creation of the Red Army and ensuring its victory during the Civil War; becoming the most determined opponent of Stalin’s creation of a monolithic party and state; being a Marxist theoretician of socialist revolution and combatting fascism; and, of course, being the originator of the very specific brand of revolutionary socialism that, as early as 1906, became known as Trotskyism.  However, this biography also explores other aspects of Trotsky’s life which are not so well-known. In particular, from a very early age, his love of writing: the world of books and publishing became his first passion; it remained his first love and, if revolutionary politics had not taken over, his life would have been a very literary one. Immediately after the November Revolution, he hoped to return to his literary work, believing his main practical work as a revolutionary was over. His writings on art and literature, when compared to the stultifying strictures of the ‘Socialist Realism’ associated with Stalinism, are remarkably sympathetic and open; while he also wrote many perceptive articles as a war correspondent, covering both the Balkan Wars and the early stages of the First World War.  Other aspects covered by this biography concern his family life, and his relationships with his children. Also explored is his love-life - while it is known he had a brief affair with the Mexican artist, Frida Kahlo, there are also suggestions he may have had other affairs. Whatever the truth of such allegations, he certainly maintained a passionate relationship with his long-term companion, Natalya Sedova; and readers should be aware that one proof of that, provided towards the end of this book, contains very explicit language.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Allan Todd
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword History
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?55ebbe1a